

export class CommonComponent {

  config: any;
  jobs: Array<{assets: Array<any>, id: string, createdAt: Date, status: string, interval?: number }> = [];
  protected limit: number = 32;

  getLogoUrl() {
    return this.config?.logoUrl || '';
  }

  getSampleUrl() {
    return this.config?.sampleUrl || '';
  }

  protected populateGallery(items: Array<{ assets: Array<any>, id: string, createdAt: Date, status: string, interval?: number }>) {

    let updated = false;
    let intersection = this.jobs.filter(job => items.map(i => i.id).includes(job.id));

    items.filter(item => ! intersection.map(i => i.id).includes(item.id)).forEach(item => {
      // console.log('new item', item);
      item.interval = Math.floor(Math.random() * 10000) + 10000; // between 10 and 20 seconds
      this.jobs.unshift(item);
      if(this.jobs.length > this.limit) {
        this.jobs.pop();
      }
      updated = true;
    });

    if(updated) {
      this.jobs.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      // console.log(this.jobs);
    }
  }

  filter(assets: Array<{ assetType: string, status: string }>): Array<any> {
    return assets.filter(asset => asset.assetType === 'output' && asset.status !== 'hidden');
  }

  filterPrint(assets: Array<{ assetType: string, status: string }>): Array<any> {
    return assets.filter(asset => asset.assetType === 'print' && asset.status !== 'hidden');
  }

  filterCustom(assets: Array<{ assetType: string, status: string }>): Array<any> {
    return assets.filter(asset => asset.assetType === 'custom' && asset.status !== 'hidden');
  }

  filterInput(assets: Array<{ assetType: string, status: string }>): Array<any> {
    return assets.filter(asset => asset.assetType === 'input' && asset.status !== 'hidden');
  }

  hasAtLeastOneOutputAsset(job: any): boolean {
    return this.filter(job.assets).length > 0;
  }

  isVisible(asset: any) {
    // console.log(asset.status, 'returning', asset.status !== 'hidden');
    return asset.status !== 'hidden';
  }
}
